var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgCasestudy4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 587,
    height: 214.11,
    viewBox: "0 0 587 214.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -697,
    y: -348.89,
    width: 1930,
    height: 563,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 2.11,
    width: 174,
    height: 253,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M373.72,356.35c-75.89,10.93-179.83-43.63-190.8-119.72S236.69,94.85,312.58,83.91s146.3,41.88,157.26,118S449.61,345.41,373.72,356.35Z",
    style: {
      fill: "#22d172"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M365.3,174.63s-4.07-21.51-4.64-25.36-3.16-14.26-4.18-18.45-5.54-13.47-7-17-5.54-6.79-9-12.34-13.8-25.7-13.8-25.7-9.49-19.24-12.09-24.56S308.32,32,306.28,27.13,301.42,12,299.72,8.9,299.5,3.58,295,3.81s-9.73,1.92-10.86,5.89.34,20.71,1.81,25,1,10.76,2.49,13.81,3.17,7.81,1.24,10.3-14.47.68-17.18-.11S251,54.52,244.66,54.07s-17.07.45-18.31,3.85a12,12,0,0,0,.68,8.94c.9,1.7,7.91,6.23,7.8,7s-12,4.41-13.34,6.9.11,11.44,3.5,13.47,5.88,2.27,5.88,3.17-7.12,6.91-6.78,10,5.65,9.5,9,10.52,7,.34,7.13,1.7-5,6.45-4.64,8.15,9.5,9.17,14.81,8.38,14.59-.57,18.2.68,20.92,5.88,26.69,8.71,9.49,5.55,11.64,10.53,3.39,22.08,3.28,23.77,5.65,3.06,9.84,2.72,26.68-3.74,30.07-3.62C353.54,179.49,365.3,174.63,365.3,174.63Z",
    style: {
      fill: "#f9f9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,173.61s2.49,10.64,2.83,15.62-70,13.58-70.55,9.51c-1-7.81-2.72-16.76-2.72-16.76s14.25,0,33.58-1.58A203.35,203.35,0,0,0,373.1,173.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.21,171.8c1-.12,6.21-.12,6.33.9,0,.34-2.15,1-2.26,1a57.17,57.17,0,0,1-8.71,2.26c-8.37,1.82-16.85,3-25.44,4-7.91,1-15.83,1.81-23.85,2-1.93.12-5.66.8-7.35-.22-3.06-1.7,4.18-4.76,6.21-5.44,1.36-.45,1.36-3-.22-2.49-2.6.91-13.23,6.57-8.14,10.19,1.36,1,4.41.68,6,.68,3.84,0,7.8-.23,11.64-.57,9.95-.79,19.79-2,29.63-3.62,6.89-1.13,14.81-1.92,21.37-4.75,1.35-.68,3.16-1.47,3.16-3.29,0-3.62-5.77-3.62-8.14-3.39C365.19,169.19,364.62,171.91,366.21,171.8Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.86,174.06c.45,1.81.79,3.51,1.13,5.32.45,2.15,2.26,7,1.58,9.28-.45,1.59-3.84,2.15-5.88,2.72-8.93,2.38-18.31,3.62-27.47,4.75A243.26,243.26,0,0,1,314,198.51c-1.58,0-5.88.68-7.24-.45s-1.24-8.38-1.58-10.3-.68-4.19-1.13-6.23c-.34-1.58-2.71-.45-2.49.91l1,5.43c.57,3.06.23,8.72,1.7,11.32.68,1.25,1.35,1.36,2.82,1.58,6.22,1.14,13.46-.11,19.68-.67,9.61-.91,19.22-2.16,28.71-3.74,6.11-1,13.34-1.7,19-4.53,1.58-.79,2.49-1.36,2.82-3.05.57-2.49-.9-6.46-1.35-8.95-.46-2.26-.91-4.41-1.36-6.56C374,171.57,371.52,172.7,371.86,174.06Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,187.19a2.81,2.81,0,0,0-1.58,2,2.94,2.94,0,0,0,.68,2.15,2.55,2.55,0,0,0,1,.9,2.18,2.18,0,0,0,1.48.23,2.9,2.9,0,0,0,1.92-1.7,3.07,3.07,0,0,0,.34-1.36c.11-.67-.57-3.39-3.17-2.71",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,189.34a412.56,412.56,0,0,1,12.67,55.92c.22,1.59,2.6.12,2.37-1.24a412.18,412.18,0,0,0-12.66-55.92C379.89,186.63,377.62,188.1,378,189.34Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,196c2.94,19.47,6,38.94,9.83,58.18.34,1.59,2.72.46,2.49-.9-3.84-19.36-6.9-38.72-9.84-58.19C297.24,193.53,294.75,194.78,295,196Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.32,170.44s5.65-.12,5.65,1.7c0,3.17-7,3.84-7,3.84Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,187.64c5.2-.68-1.36,2.15-2.49,2.49-3.39,1-6.89,1.7-10.28,2.38-9,1.81-18.32,3.06-27.48,4.08a181.45,181.45,0,0,1-27.13,1.47c-2.72-.11-5.88-.11-8.48-1-4.52-1.59-.12-3.85,2.94-4,1.35-.12,1.24-2.83-.23-2.83-4.41.22-10.85,5.54-5,8.83,5.65,3.17,15,1.81,21,1.47,18.42-.91,38.66-2.49,56.3-8.26,1.47-.46,4-1,4.75-2.5,1.35-2.71-1.47-5.43-4.07-5.09C374.57,185,374.57,187.76,376,187.64Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,199.19s-8.37-2-8.48-3.74c-.23-2.94,8.14-4,8.14-4Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.05,175.53s-8.93,1.13-9.05,4.76c-.11,3.84,9.73,2,9.73,2Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,187.08s1.7-.23,1.58.34a7.57,7.57,0,0,1-1.46,1.92Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,175.87c.34-3.17-.79-6.9-1.24-10-1.13-7-2.49-13.92-4.18-20.94-2.83-12.23-5.77-28.19-14.7-37.58-9.38-10-14.7-23.44-21.26-35.55-4.07-7.58-8.7-15.05-11.75-23.09s-5.54-16.19-8.15-24.34c-2-6.23-3.5-13.24-6.78-19-2.26-4.07-7.69-3.85-11.64-1.92-5.77,2.83-6.67,10.07-6.45,15.73.45,9.63,3.51,19.25,5.43,28.64.34,1.93,2.82,9.51,1.24,11.1s-7.57.11-9.5-.12c-8.25-1-16.39-2.94-24.53-4.53-7.35-1.47-15.94-3.5-23.29-1-5.09,1.69-8.93,7.13-6.44,12.45,3,6.56,12.32,10.19,18.65,12.56s16.51,5.55,22.5.57c4.75-3.85,3.39-10-.79-13.47-4.75-4-11.08-6.57-16.85-8.72-1.24-.45-1.92,2.27-.56,2.72a70,70,0,0,1,13.11,6.22c2.6,1.59,6,3.63,6,7-.12,6.34-9.16,6.12-13.46,5.44a55.25,55.25,0,0,1-19.9-7.81c-2.6-1.7-6.56-4.19-7.12-7.48C225.1,56,234.26,55,238.79,55c14.13,0,27.92,5.44,41.94,6.8,2.72.22,7.69,1.24,9.61-1.25,2.38-2.94-.23-10.53-.9-13.7-1.7-8.37-4.07-16.75-5.09-25.35-.45-4.19-.79-9.74,1.92-13.25,1.92-2.49,8.37-4.86,11.08-2.49,2.94,2.72,4.18,9.85,5.31,13.59,2.27,6.79,4.3,13.58,6.56,20.26,4.75,14.49,12,27.28,19.22,40.64,4.86,9,8.26,19.24,15.49,26.94,9.84,10.3,13.23,24.56,16.4,38.15,1.58,6.68,2.94,13.35,4.07,20.15.56,3.28,1.81,7.35,1.47,10.64C365.75,178,367.9,177.46,368,175.87Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54,73.54c-6.1-.79-13.79.45-17,6.34-5.42,10,3.85,16.75,12.21,19.81,8.14,3,55.63,11,45.12-9.74-3.85-7.58-14.48-10.52-22.28-11.43-1.47-.23-1.47,2.6-.11,2.83,6.67.79,15.6,2.94,19.78,8.6,9.28,12.68-18,11.21-23.74,10.76a77.7,77.7,0,0,1-13.45-2.15c-5.2-1.36-13.23-3.74-16.06-9.06-5.2-9.85,8.26-14.15,15.38-13.24C238.9,76.6,238.9,73.77,237.54,73.54Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.89,97.31c-5.66,1.36-10.4,8.94-7.12,14.49,2.26,3.85,7.57,6,11.53,7.36,7,2.38,14.24,2.15,21.59,1.7,6.56-.46,13.23-1,19.56-2.83,2.83-.8,6.9-2,8-5.21,2.6-6.91-6.67-11.77-12.1-12.45-1.35-.12-2.15,2.6-.79,2.71a18.85,18.85,0,0,1,4.3,1c2.94,1.13,8.7,5,5.65,8.83-1.92,2.49-8.14,3.06-10.74,3.51-4,.68-8,1.13-12.1,1.47-9,.68-18.31.91-26.68-3.17-3.17-1.58-7.12-3.62-7-7.69a7.59,7.59,0,0,1,5.77-7C233,99.8,233.36,97,231.89,97.31Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,118.82c-4.75,1.24-10.63,6.11-7.24,11.43,4.18,6.57,17.86,7.36,24.53,7.13,7.81-.22,22.39-2,26.35-10.3,3.05-6.45-3.62-10-9.05-11-1.69-.34-2.37,1.7-.56,2,5.65,1,10.51,5.21,5,10.41-5.43,5-15.26,6.34-22.27,6.57-6.11.23-14.81-.45-19.9-4.42-5.31-4.07.34-8.94,4.75-10.07C246.14,120.4,244.21,118.48,242.86,118.82Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.13,137.27c5,1.7,10.06,3.4,15.15,4.87,8.14,2.37,16.28,2.83,22.38,9.51,7.24,7.92,7.35,20.94,8.82,31.13.23,1.47,2.83.56,2.72-.8-1.47-10.07-1.59-22.86-8.37-31-2.71-3.17-6-6.34-10.06-7.7-3.17-1-6.79-1.36-10.06-2.26-6.34-1.7-12.67-3.74-18.88-5.89C265.58,134.78,263.66,136.7,265.13,137.27Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.14,80.67s12.77,18.79,17.3,23.66,16.84,37.13,17.63,47.32,5.32,21.62,4.53,24.22-5.88,2.27-5.09-1.47-6.22-28.87-7-33.85-2.83-20.94-6.78-26.82S339,99.46,336.92,94.48,330.14,80.67,330.14,80.67Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,69.8a43.33,43.33,0,0,0-11.76,16.64c-.57,1.36,2.26,1.82,2.71.46a40.37,40.37,0,0,1,11-15.74C288,70.14,285.59,68.9,284.58,69.8Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.42,85.31c1.58,1.7,9.16,5.32,9.27,9.74s-5.77,5.66-5.77,5.66,11.31,5.66,11.19,10.64-6.21,6.11-6.21,6.11,7.8,4.41,7.91,11.77-20.35,7.13-20.35,7.13,14.25-9.05,14.25-11.77-6.45-7.13-6.45-7.13,6.33-4,5.54-6.57-10.4-10.41-10.4-10.41,5.09-4.41,3.84-7.24-3.39-7.7-3.39-7.7Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,67.31s2.6,4,1.58,6.23-5.43,6.68-5.43,6.68,9.16,1.58,10.52-2.83S266.49,67.31,266.49,67.31Z",
    style: {
      fill: "#1a2e44"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M488.05,138c.8-1.41,5.29-2.79,6.41-.21s19.49,35.72,19.08,37-47.71,25.28-49.76,23.65c-.57-.45-6.75-2.09-4-9.14C466.72,171.62,488.05,138,488.05,138Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.93,160l44.18-23.08a3.72,3.72,0,0,1,2.52-.63c1,.25,1.53,1.26,2.06,2.07,6.26,11.61,12.6,23.16,18.86,34.77a411.28,411.28,0,0,0-47.11,25,2.73,2.73,0,0,1-2.45.57c-.48-.19-.73-.65-1.06-1.07a206.52,206.52,0,0,1-17.66-34.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.19,160.88l40.3-21.06c2.54-1.31,4.48-3.26,7.42-.77,1.07.95,1.84,3.36,2.44,4.56l5.36,9.87c3.73,6.78,7.39,13.62,11.12,20.41.13-.55.38-1.08.51-1.63a406.29,406.29,0,0,0-41.43,21.61,32.28,32.28,0,0,1-4.32,2.59c-3.3,1.35-4,.64-5.74-2.21-2-3.32-4.05-6.76-5.87-10.24a225.35,225.35,0,0,1-10-21.28c-.48-1.18-1.88.46-1.56,1.44a206.57,206.57,0,0,0,11.65,24.23c1.8,3.16,3.73,8.35,6.5,10.76,1.23,1.15,2.05,1.07,3.64.39,3.85-1.78,7.51-4.52,11.09-6.64q5.77-3.33,11.69-6.45c8.11-4.31,16.32-8.37,24.74-12.15a1.2,1.2,0,0,0,.51-1.63l-13.16-24.16c-1.93-3.62-3.66-8.41-6.28-11.49a3.3,3.3,0,0,0-3.58-1.44c-2.93.39-6.48,3.27-9,4.58-4,2.13-8.16,4.25-12.18,6.38-8.17,4.25-16.21,8.51-24.37,12.76C440.8,159.52,440.92,161.54,442.19,160.88Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.34,163.22l20.72,2.56,10.36,1.29c1.85.23,4.2,1,6,.24,2.24-.86,3.63-4.06,4.67-5.88a65.15,65.15,0,0,0,3.92-7.84,70.54,70.54,0,0,0,4.32-15.74c.13-1-1.6-2.2-1.82-.92a63.75,63.75,0,0,1-3.69,14.14c-1.56,4-5.17,13.94-9.94,14.54-2.55.31-5.8-.71-8.27-1L459,163.52l-18.13-2.24C439.67,161.07,440.35,163.1,441.34,163.22Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.18,140s-5.34,21.88-6.66,24.47-6.77,2-6.77,2,5.92-7.84,7-10.27,5.42-16.93,5.42-16.93Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.65,88.47c1.34.06,4,2.87,2.56,4.66S127.09,121,126,121.15,89.35,95.34,89.79,93.21c.12-.59-1-5.79,5.26-6.39C110.73,85.32,143.65,88.47,143.65,88.47Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.05,62.61l33.65,24a3.09,3.09,0,0,1,1.41,1.63,3.38,3.38,0,0,1-.76,2.3c-6.24,9-12.41,18-18.65,27A342.64,342.64,0,0,0,89.5,92.1c-.63-.37-1.29-.85-1.34-1.59a2.43,2.43,0,0,1,.39-1.19,171.12,171.12,0,0,1,18.81-26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,63.15q15.39,11,30.7,21.91c1.93,1.39,4.1,2.09,3.36,5.2-.3,1.15-1.8,2.62-2.46,3.52q-2.64,3.84-5.29,7.66c-3.62,5.31-7.31,10.59-10.93,15.89.45-.11.94-.12,1.4-.23A337.56,337.56,0,0,0,94.71,94.55a26.9,26.9,0,0,1-3.54-2.23c-2.23-1.93-2-2.69-.51-5.07,1.69-2.75,3.48-5.53,5.37-8.19a189.46,189.46,0,0,1,12-15.39c.7-.8-1-1.21-1.65-.61A171.47,171.47,0,0,0,92.81,80.77c-1.66,2.52-4.78,5.89-5.52,8.84-.39,1.35,0,1.93,1.08,2.85,2.76,2.18,6.16,3.86,9.08,5.71q4.62,3,9.15,6.24c6.24,4.38,12.31,8.92,18.27,13.74a1,1,0,0,0,1.4-.23l12.94-18.81c1.95-2.79,4.85-5.86,6.14-9a2.72,2.72,0,0,0-.27-3.18c-1.39-2-4.85-3.57-6.78-5-3.08-2.17-6.2-4.45-9.29-6.62-6.21-4.45-12.38-8.8-18.58-13.25C110,61.6,108.51,62.45,109.47,63.15Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,63.39l5.88,16.3,2.94,8.14c.52,1.46.86,3.47,2.06,4.52,1.47,1.33,4.37,1.16,6.1,1.25a53.44,53.44,0,0,0,7.27,0A58.44,58.44,0,0,0,145,90.85c.77-.28,1-2,0-1.7a52.56,52.56,0,0,1-11.85,2.58c-3.54.34-12.25,1.4-14.49-1.9-1.18-1.77-1.64-4.56-2.34-6.5-.81-2.23-1.65-4.56-2.45-6.79l-5.14-14.25C108.39,61.35,107.14,62.62,107.42,63.39Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,91.54s-18.19,4.26-20.6,4.25-4-4.23-4-4.23,8,1.43,10.24,1.34,14.55-2.34,14.55-2.34Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7,75C83.52,45.69,44,64.53,50.94,80.68c10.32,24.17,39.2-70-48.38-14.94",
    style: {
      fill: "none",
      stroke: "#1a2e44",
      strokeWidth: "1.600000023841858px",
      strokeDasharray: "6,3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.35,181.26c-8.92-26.24-44-15.54-40.31-1.29,5.54,21.34,41.25-53.16-38.26-18.43",
    style: {
      fill: "none",
      stroke: "#1a2e44",
      strokeWidth: "1.600000023841858px",
      strokeDasharray: "6,3"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCasestudy4);
export default __webpack_public_path__ + "static/media/img__casestudy4.c2d5c8f52068a75578b0946b70b869e9.svg";
export { ForwardRef as ReactComponent };